import React, { useState } from "react";
import { Card, CardBody, CardTitle, CardText, Row, Col, Button, CardFooter,Badge } from "reactstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import 'react-circular-progressbar/dist/styles.css';
import User from '../../../../../assets/fonts/user.svg';
import { useNavigate } from 'react-router-dom';
import '../style.css'
import { errorToast } from "../../../../../_helper/helper";
import CustomProgressBar from "../../Components/CustomProgressBar";
import { FaUserTie, FaVideo, FaChartLine, FaBell, FaChevronRight } from 'react-icons/fa'; 

const SubAreaCard = ({ name, percentage, cameras, area, items, areaData, allData, filters,index }) => {

    const progressColor = items?.AreaCompliance >= 90 ? "#28a745" : items?.AreaCompliance > 50 && items?.AreaCompliance < 90 ? "#D99104" : items?.AreaCompliance <= 50 ? '#ff0000' : '#1e67d5';
    const [role, setrole] = useState(JSON.parse(localStorage.getItem('role')));
    const navigate = useNavigate()
    const handleNavigate = (data) => {
        const idData = {
            id: data?.AreaId,
            name: data?.AreaName,
            owner: data?.AreaOwner,
            ownerId: data?.AreaOwnerId
        };
        let getfilss = JSON.parse(localStorage.getItem('areaAnalysisFilters'))
        const newFils = {
            weekly: getfilss?.week,
            month: getfilss?.month,
            shift: getfilss?.shifts,
            date: getfilss?.date

        }
        localStorage.setItem('FactoryChartsFilters', JSON.stringify(newFils))
        // console.log("getfilssgetfilss", getfilss)
        // localStorage.setItem('areaPayload', JSON.stringify(id));
        // navigate(`${process.env.PUBLIC_URL}/areaanalysis/details/${items.AreaName}/${role}`)
        localStorage.setItem('areaPayload', JSON.stringify(idData));
        console.log('idDataaaa', idData)
        localStorage.setItem('areaanalysisalertfilters', JSON.stringify(filters))
        navigate(`${process.env.PUBLIC_URL}/areaanalysis/alerts/${items.AreaName}/${role}`, { state: { idData } })
    }

const get_area_camera_count=(area)=>{
    const area_cameras={
      "CDC-Logistics":13,
      "Personal-Products":11,
      "Warehouse-RMS":14,
      "Personal-Wash":12,
    }

    return area_cameras[area]
  }

    return (
        <>
        {/* <Card
            style={{
                borderRadius: "12px",
                border: "1px solid #ECECEC",
                minHeight: '200px'
            }}
        >
            <CardBody  >
                <div className="d-flex justify-content-between align-items-center  w-100 ">
                    <div style={{ display: "flex",justifyContent:'space-between' }} className="w-100">
                        <CardTitle tag="h5" className="mt-2 ellipsis-text" style={{width:'80%'}}>
                            <img 
                                src={User}
                                alt="user"
                                style={{ marginBottom: "2px", marginRight: "2px" }}
                            /> 
                            { items?.AreaOwner} 
                            
                        </CardTitle>
                    <CustomProgressBar percentage={items?.AreaCompliance} progressColor={progressColor} />
                    </div>
                </div>
                <div
                    style={{ border: "1px solid #ECECEC", width: "100%" }}
                    className="mt-2"
                ></div>
                <CardText className="mt-3 ">
                    <div className="d-flex justify-content-between">
                        {items?.SubAreas?.length} Camera<br />
                        <CardText style={{ fontWeight: 500, fontSize: '16px' }}>{items?.AreaName}</CardText>
                    </div>
                    <div className="d-flex justify-content-between">
                        {items?.SubAreas
                            ? items.SubAreas?.reduce((totalViolations, item) => totalViolations + (item.Violations || 0), 0)
                            : 0} Alerts <br />
                    </div>

                </CardText>



            </CardBody>
            <div className="d-flex justify-content-center align-items-center mb-2">
                <Button
                    outline
                    size="sm"
                    style={{
                        width: "90%",
                        padding: "6px",
                        borderRadius: "4px",
                        border: "1px solid #ECECEC",
                    }}
                    className="newDesignCardBtn "
                    onClick={(e => handleNavigate(items))}
                    color="primary"
                >
                    See Details
                </Button>

            </div>
        </Card> */}
        <Card key={index} style={cardStyle}>
                  <CardBody style={cardBodyStyle}> 
                    <Row style={headerStyle}>
                      <Col xs={8}>
                        <div style={titleSectionStyle}>
                          <h3 style={areaNameStyle} className="ellipsis-text">{items.AreaName}</h3>
                          <div style={ownerSectionStyle}>
                            <FaUserTie style={iconStyle} />
                            <span style={ownerTextStyle} className="ellipsis-text">Area Owner: {items.AreaOwner}</span>
                          </div>
                        </div>
                      </Col>
                      <Col xs={4} style={complianceSectionStyle}>
                        <div style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '50%',
                            // background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                            background: progressColor,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)'
                            }}>
                          <span style={complianceTextStyle}>{items.AreaCompliance}%</span>
                        </div>
                        <span style={complianceLabelStyle}>Compliance</span>
                      </Col>
                    </Row>
         
                    {/* <div style={subAreaStyle}>
                      <span style={subAreaTextStyle}>{data.sub_area}</span>
                    </div> */}
         
                    <Row style={statsRowStyle}>
                      <Col xs={4} style={statItemStyle}>
                        <div style={statIconContainerStyle}>
                          <FaVideo style={statIconStyle} />
                        </div>
                        <div style={statTextContainerStyle}>
                          {/* <span style={statNumberStyle}>{items.SubAreas?.length | 0}</span> */}
                          <span style={statNumberStyle}>{get_area_camera_count(items.AreaName) | "N/A"}</span>
                          <span style={statLabelStyle}>Cameras</span>
                        </div>
                      </Col>
                      
                      <Col xs={4} style={statItemStyle}>
                        <div style={statIconContainerStyle}>
                          <FaChartLine style={statIconStyle} />
                        </div>
                        <div style={statTextContainerStyle}>
                          <span style={statNumberStyle}>{items.AreaCompliance}%</span>
                          <span style={statLabelStyle}>Compliance</span>
                        </div>
                      </Col>
                      
                      <Col xs={4} style={statItemStyle}>
                        <div style={statIconContainerStyle}>
                          <FaBell style={alertIconStyle} />
                        </div>
                        <div style={statTextContainerStyle}>
                          <span style={alertNumberStyle}>{items?.SubAreas
                            ? items.SubAreas?.reduce((totalViolations, item) => totalViolations + (item.Violations || 0), 0)
                            : 0}</span>
                          <span style={statLabelStyle}>Alerts</span>
                        </div>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-center align-items-center mb-2">
                        <Button
                            outline
                            size="sm"
                            style={{
                                width: "90%",
                                padding: "6px",
                                borderRadius: "4px",
                                border: "1px solid #ECECEC",
                            }}
                            className="newDesignCardBtn "
                            onClick={(e => handleNavigate(items))}
                            color="primary"
                        >
                            See Details
                        </Button> 
                    </div>        
                    {/* Supervisors Section */}
                    <div style={supervisorsSectionStyle}>
                      <div style={supervisorsHeaderStyle}>
                        <span style={supervisorsTitleStyle}>Supervisors</span>
                        <Badge color="primary" style={badgeStyle}>{items.Supervisors?.length || 0}</Badge>
                      </div>
                      
                      <div style={supervisorsListStyle}>
                        {items?.Supervisors?.length > 0 ? items.Supervisors.map((supervisor, idx) => (
                          <div key={idx} style={supervisorItemStyle}>
                            <div style={avatarStyle}>
                              {supervisor.supervisor_name?.split(' ').map(n => n[0]).join('')}
                            </div>
                            <span style={supervisorNameStyle}>{supervisor.supervisor_name}</span>
                          </div>
                        )): 
                        <div className="w-100 border b-r-10 p-2 text-center"> 
                            <span className='f-light'>No Supervisors</span>
                          </div> 
                        }
                        
                        {/* {data.supervisor_list.length > 3 && (
                          <div style={moreSupervisorsStyle}>
                            <span style={moreTextStyle}>
                              +{data.supervisor_list.length - 3} more
                            </span>
                            <FaChevronRight style={chevronStyle} />
                          </div>
                        )} */}
                      </div>
                    </div>
                  </CardBody>
                </Card>
        </>
    )
}

export default SubAreaCard;









const cardStyle = {
  border: 'none',
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  overflow: 'hidden',
  background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//   maxWidth: '500px', 
};

const cardBodyStyle = {
  padding: '24px'
};

const headerStyle = {
  marginBottom: '16px',
  alignItems: 'center'
};

const titleSectionStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
};

const areaNameStyle = {
  fontSize: '22px',
  fontWeight: '700',
  color: '#2c3e50',
  margin: '0',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent'
};

const ownerSectionStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
};

const iconStyle = {
  color: '#6c757d',
  fontSize: '16px'
};

const ownerTextStyle = {
  fontSize: '14px',
  color: '#6c757d',
  fontWeight: '500'
};

const complianceSectionStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};

 

const complianceTextStyle = {
  color: 'white',
  fontSize: '16px',
  fontWeight: '700'
};

const complianceLabelStyle = {
  fontSize: '12px',
  color: '#6c757d',
  marginTop: '4px',
  fontWeight: '500'
};

const subAreaStyle = {
  marginBottom: '20px',
  padding: '12px 16px',
  backgroundColor: '#e3f2fd',
  borderRadius: '12px',
  border: '1px solid #bbdefb'
};

const subAreaTextStyle = {
  fontSize: '14px',
  color: '#1976d2',
  fontWeight: '600'
};

const statsRowStyle = {
  marginBottom: '24px'
};

const statItemStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center'
};

const statIconContainerStyle = {
  width: '48px',
  height: '48px',
  borderRadius: '12px',
  backgroundColor: '#f0f4f8',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '8px'
};

const statIconStyle = {
  fontSize: '20px',
  color: '#3498db'
};

const alertIconStyle = {
  fontSize: '20px',
  color: '#e74c3c'
};

const statTextContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px'
};

const statNumberStyle = {
  fontSize: '20px',
  fontWeight: '700',
  color: '#2c3e50'
};

const alertNumberStyle = {
  fontSize: '20px',
  fontWeight: '700',
  color: '#e74c3c'
};

const statLabelStyle = {
  fontSize: '12px',
  color: '#6c757d',
  fontWeight: '500'
};

const supervisorsSectionStyle = {
  borderTop: '2px solid #e9ecef',
  paddingTop: '20px'
};

const supervisorsHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px'
};

const supervisorsTitleStyle = {
  fontSize: '16px',
  fontWeight: '600',
  color: '#2c3e50'
};

const badgeStyle = {
  backgroundColor: '#1e67d6 !important',
  color: 'white',
  borderRadius: '12px',
  fontSize: '12px',
  fontWeight: '600',
  padding: '4px 8px'
};

const supervisorsListStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  height: '150px',
  overflowY: 'auto',
  alignItems: 'center', 
};

const supervisorItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '8px 12px',
  backgroundColor: '#f8f9fa',
  borderRadius: '8px',
  transition: 'background-color 0.2s ease',
  width: '100%'
};

const avatarStyle = {
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  backgroundColor: '#1e67d6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fontSize: '12px',
  fontWeight: '600'
};

const supervisorNameStyle = {
  fontSize: '14px',
  color: '#2c3e50',
  fontWeight: '500'
};

const moreSupervisorsStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 12px',
  backgroundColor: '#e3f2fd',
  borderRadius: '8px',
  cursor: 'pointer'
};

const moreTextStyle = {
  fontSize: '14px',
  color: '#1976d2',
  fontWeight: '500'
};

const chevronStyle = {
  fontSize: '12px',
  color: '#1976d2'
};